import React from 'react';
import { Route } from 'react-router-dom';
import AlumniManagement from '@/pages/alumni/AlumniManagement';

export const alumniRoutes = (
  <React.Fragment>
    <Route path="alumni" element={<AlumniManagement />} />
    <Route path="alumni/list" element={<AlumniManagement />} />
  </React.Fragment>
);
